import { createSelector } from '@ngrx/store';
import { googleState } from '../root';

export const getGooglePlaceDetails = (placeId: string) =>
    createSelector(googleState, (google) => google?.places?.data?.find(place => place.data.place_id === placeId) || null);
